"use client";

import { SpecOptionPills } from "@/components/listing/FurnitureOptionalDimensionsFields";
import {
  SEWING_MACHINE_TYPES,
  type SewingMachineSpecFormState,
  type SewingMachineType,
} from "@/lib/listing/sewingMachineListingSpec";
import { cn } from "@/lib/utils";

interface SewingMachineSpecFieldsProps {
  value: SewingMachineSpecFormState;
  onChange: (next: SewingMachineSpecFormState) => void;
  className?: string;
}

function formatTypeLabel(value: SewingMachineType): string {
  switch (value) {
    case "manual":
      return "Manual";
    case "electric":
      return "Electric";
    case "industrial":
      return "Industrial";
  }
}

/**
 * Step 2 panel for canonical `sewing-machine`.
 * Type (Manual / Electric / Industrial) required.
 */
export default function SewingMachineSpecFields({
  value,
  onChange,
  className = "",
}: SewingMachineSpecFieldsProps) {
  return (
    <div className={cn("space-y-6", className)}>
      <div className="space-y-2">
        <p className="text-sm font-medium text-foreground">
          What type is it? <span className="text-red-500">*</span>
        </p>
        <SpecOptionPills
          options={[...SEWING_MACHINE_TYPES]}
          selected={value.sewingMachineType}
          onSelect={(sewingMachineType: SewingMachineType) =>
            onChange({ ...value, sewingMachineType })
          }
          formatLabel={formatTypeLabel}
        />
      </div>
    </div>
  );
}
